import * as React from 'react';
import { nameIsEpiFormField, STR_CC, STR_C } from '../../helpers/stb.helpers';
import EventService from '../CalculationComponents/calculationComponents.eventservice';
import ValidationService from '../../services/validation.service';
import Console from 'sos-common/js/utils/console.log';
import { string } from 'prop-types';
export interface ValidatorProps {
  elementNamesAndValidators: formElementValidationObject[];
  stepCount: number;
}

export interface ValidatorState {
  formIsValid: boolean;
}

export interface ProperElement {
  element: HTMLElement;
  step: number;
  regex?: string;
  isValid?: boolean;
  isRequired?: boolean;
  type?: string;
  elementGroup?: HTMLElement[];
}

interface formElementValidationObject {
  ElementName: string;
  Step: number;
  Regexp: string;
  Required: boolean;
  Type: string;
  Guid: string;
}

/**
 * On load event of the document; traverses all elements and their validators and registers them to the ValidationService. 
 */
export class Validator extends React.Component<ValidatorProps, ValidatorState> {
  constructor(props: ValidatorProps) {
    super(props);

    this.state = {
      formIsValid: false
    };
  }

  componentDidMount() {
    this.setupListener();
  }

  setupListener = () => {
    window.addEventListener('load', () => {
      this.initializeProperElements();
    });

    document.body.addEventListener('change', e => {
      let target = e.target as HTMLInputElement;
      let name = target.attributes.getNamedItem('name');
      if (target.type === 'checkbox' || target.type === 'radio') {
        if (name && nameIsEpiFormField(name.value)) {
          ValidationService.validateStandardComponent(name.value);
        }
      }
    });

    document.body.addEventListener('focusout', e => {
      let target = e.target as HTMLElement;
      let name = target.attributes.getNamedItem('name');
      if (name && nameIsEpiFormField(name.value)) {
        ValidationService.validateStandardComponent(name.value);
      }
    });
  };

  /**
   * Different input elements has slightly different validation logic
   */
  initializeProperElements = () => {
    const { elementNamesAndValidators } = this.props;
    let elements: ProperElement[] = [];

    elementNamesAndValidators.forEach(validationObject => {

      // Radio or checkboxes
      if (validationObject.Type === 'choice') {
        let choiceNodeList = document.getElementsByName(validationObject.ElementName);
        let elementList: HTMLElement[] = [];
        [].forEach.call(choiceNodeList, element => {
          elementList.push(element);
        });
        elements.push({
          element: document.getElementById(validationObject.Guid),
          step: validationObject.Step,
          regex: validationObject.Regexp,
          isRequired: validationObject.Required,
          type: validationObject.Type,
          elementGroup: elementList.slice()
        });
        return;
      }

      // All other elements
      let nodeList = document.getElementsByName(validationObject.ElementName);
      if (!nodeList.length) nodeList = document.getElementsByName(STR_CC + validationObject.ElementName);
      if (nodeList.length) {
        [].forEach.call(nodeList, element => {
          elements.push({
            element,
            step: validationObject.Step,
            regex: validationObject.Regexp,
            isRequired: validationObject.Required,
            type: validationObject.Type
          });
        });
      } else {
        Console.warn(`failed to add: ${validationObject.ElementName}`);
      }
    });

    ValidationService.setFormElements(elements);
    for (let i = 0; i < this.props.stepCount; i++) {
      ValidationService.validateStep(i);
    }
  };

  public render() {
    return null;
  }
}
